import { Instagram, MessageCircle, Phone, Mail, MapPin, Clock, Youtube } from "lucide-react";
import { CONTACT, waLink } from "../data/site";
import { scrollToId } from "../lib/smooth";

export const Footer = ({ onBook }) => {
    return (
        <footer id="contact" data-testid="site-footer" className="border-t border-white/5 bg-[#081226] px-6 pt-20 pb-10">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <span className="flex items-center gap-3">
                            <img src="/assets/logo_mark.png" alt="Ink of Destiny" className="h-14 w-auto" />
                            <span className="font-display italic text-2xl text-[#F0EBE0]">Ink of <span className="text-[#C9A962]">Destiny</span></span>
                        </span>
                        <p className="mt-4 font-display italic text-lg text-[#A19D94]">Where your handwriting meets your numbers.</p>
                        <div className="mt-6 flex gap-3">
                            <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                                className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-[#A19D94] hover:text-[#C9A962] hover:border-[#C9A962]/50 transition-colors">
                                <Instagram size={18} />
                            </a>
                            <a data-testid="footer-youtube" href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"
                                className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-[#A19D94] hover:text-[#C9A962] hover:border-[#C9A962]/50 transition-colors">
                                <Youtube size={18} />
                            </a>
                            <a data-testid="footer-whatsapp" href={waLink("Hi Maitrii!")} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
                                className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-[#A19D94] hover:text-[#C9A962] hover:border-[#C9A962]/50 transition-colors">
                                <MessageCircle size={18} />
                            </a>
                            <a data-testid="footer-phone" href={`tel:+91${CONTACT.phone}`} aria-label="Call"
                                className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-[#A19D94] hover:text-[#C9A962] hover:border-[#C9A962]/50 transition-colors">
                                <Phone size={18} />
                            </a>
                            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} aria-label="Email"
                                className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-[#A19D94] hover:text-[#C9A962] hover:border-[#C9A962]/50 transition-colors">
                                <Mail size={18} />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-xs uppercase tracking-[0.25em] text-[#5C5A56] mb-5">Explore</p>
                        <div className="flex flex-col gap-3">
                            {[["About", "#about"], ["Services", "#services"], ["Pricing", "#pricing"], ["How It Works", "#how-it-works"]].map(([label, href]) => (
                                <button key={href} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => scrollToId(href)}
                                    className="text-left text-sm text-[#A19D94] hover:text-[#C9A962] transition-colors w-fit">
                                    {label}
                                </button>
                            ))}
                            <button data-testid="footer-book" onClick={onBook} className="text-left text-sm text-[#A19D94] hover:text-[#C9A962] transition-colors w-fit">
                                Book Consultation
                            </button>
                        </div>
                    </div>

                    <div className="md:col-span-4">
                        <p className="text-xs uppercase tracking-[0.25em] text-[#5C5A56] mb-5">Visit Us</p>
                        <a data-testid="footer-address" href={CONTACT.maps} target="_blank" rel="noopener noreferrer"
                            className="flex gap-3 text-sm text-[#A19D94] hover:text-[#C9A962] transition-colors leading-relaxed">
                            <MapPin size={16} className="text-[#C9A962] shrink-0 mt-0.5" />
                            {CONTACT.address}
                        </a>
                        <p className="mt-4 flex gap-3 text-sm text-[#A19D94]">
                            <Clock size={16} className="text-[#C9A962] shrink-0 mt-0.5" /> Open Daily · {CONTACT.hours}
                        </p>
                        <p className="mt-3 flex gap-3 text-sm text-[#A19D94]">
                            <Phone size={16} className="text-[#C9A962] shrink-0 mt-0.5" /> {CONTACT.phoneDisplay} · +91 96647 94543
                        </p>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-[#5C5A56]">© {new Date().getFullYear()} INK OF DESTINY · Maitrii Shahh. All rights reserved.</p>
                    <div className="flex gap-6">
                        <a href="#contact" data-testid="footer-privacy" className="text-xs text-[#5C5A56] hover:text-[#C9A962] transition-colors">Privacy Policy</a>
                        <a href="#contact" data-testid="footer-terms" className="text-xs text-[#5C5A56] hover:text-[#C9A962] transition-colors">Terms & Conditions</a>
                        <a href="/admin/login" data-testid="footer-admin-link" className="text-xs text-[#5C5A56] hover:text-[#C9A962] transition-colors">Admin</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};
